module.exports = __webpack_public_path__ + "static/media/MIR-UST.a7b8ad65.svg";